/**
 * Sharing a recipe by link (docs/plans/recipes.md, "Sharing, privately"). The link is
 * `<BASE_URL>/shared#r=<token>`: the token sits after "#", which browsers never send to a
 * server, so it stays out of proxy logs and Referer headers. The app sends it only in POST
 * bodies. Shared by the server (making links) and the web app (reading them), so kept free of zod.
 */
import { APP_NAME } from './brand';

/** Where a shared link opens in the app. */
export const SHARED_RECIPE_PATH = '/shared';

/** A link's token: 32 random bytes, base64url without padding. */
export const SHARE_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

/** Links one person can have on at once (one per recipe). */
export const MAX_ACTIVE_LINKS = 100;

/** The address to send: the token goes in the fragment, never the path or query. */
export function shareLinkUrl(base: string, token: string): string {
  return `${base.replace(/\/+$/, '')}${SHARED_RECIPE_PATH}#r=${token}`;
}

/** Who shared it, as the link shows it: their display name when they chose to show it, else nothing (never an email). */
export function sharerName(showName: boolean, name: string | null | undefined): string | null {
  const trimmed = name?.trim() ?? '';
  return showName && trimmed ? trimmed : null;
}

/** "Shared by Pat", or "Shared by a Grams member" without a name. */
export function sharedByLine(name: string | null): string {
  return name ? `Shared by ${name}` : `Shared by a ${APP_NAME} member`;
}

/** "Added by 3 people", for the owner. A count only, never who. */
export function addedByLine(adds: number): string {
  if (adds <= 0) return 'Nobody has added it yet';
  return adds === 1 ? 'Added by 1 person' : `Added by ${adds.toLocaleString('en-US')} people`;
}
